
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"40","viewBox":"0 0 120.595 36.962"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Woli Positivo"}},[_c('path',{staticClass:"blue",attrs:{"d":"M6.925 5.357l7.135 23.745 6.6-23.745h7.53l6.6 23.745L41.9 5.357h6.925l-10.2 31.558H30.95l-6.527-22.809-6.55 22.809h-7.65L0 5.357z","data-name":"Caminho 281"}}),_c('path',{staticClass:"blue",attrs:{"d":"M66.111 0a22.465 22.465 0 019.423 1.872 12.7 12.7 0 016.831 7.439 26.866 26.866 0 011.544 9.5 23 23 0 01-1.895 9.779 13.222 13.222 0 01-5.825 6.223 20.306 20.306 0 01-9.708 2.059 23.6 23.6 0 01-10.691-2.293 13.466 13.466 0 01-6.6-7.837 23.667 23.667 0 01-1.263-8.118c0-6.925 1.731-11.884 5.17-14.832 2.971-2.5 7.3-3.79 13.007-3.79m-.211 4.234a13.067 13.067 0 00-4.187.608 9.055 9.055 0 00-4.234 2.854c-2.012 2.573-2.48 6.808-2.48 10.785 0 4.071.561 8.211 2.667 10.808a8.784 8.784 0 002.924 2.41 12.337 12.337 0 005.31 1.006c3.2 0 6.5-.819 8.492-3.72a14.622 14.622 0 002.105-5.685 30.712 30.712 0 00.328-4.819 28.394 28.394 0 00-.515-5.919 13.544 13.544 0 00-2.012-4.749c-1.965-2.877-5.217-3.579-8.4-3.579","data-name":"Caminho 282"}}),_c('path',{staticClass:"blue",attrs:{"d":"M85.691.023h7.837v20.7c.117 2.62.211 4.375.351 5.24.351 2.269 1.848 3.626 4.421 4.094a35.19 35.19 0 005.17.3h7.533v6.574h-8.352a36.242 36.242 0 01-8.586-.678 10.578 10.578 0 01-7.743-7.767 34.051 34.051 0 01-.654-7.763V.023z","data-name":"Caminho 283"}}),_c('path',{staticClass:"blue",attrs:{"d":"M112.758 9.591h7.837v27.371h-7.837z","data-name":"Retângulo 21"}}),_c('path',{staticClass:"red",attrs:{"d":"M112.758 5.217h7.837v3.182h-7.837z","data-name":"Retângulo 22"}})])])
          )
        }
      }
    